/* Component Dependencies */
var travelByDestinationTemplate = require('templates/travelByDestination.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'travelByDestination',
  template: {
    'travelByDestination': travelByDestinationTemplate
  },
  events: {
    'click .details-panel-container': 'togglePanel',
    'click .description-info': 'triggerAnchorClick'
  },
  togglePanel: function(event) {
    if(event.target.nodeName !== "A") {
      var $currentElement = $(event.target).closest('.details-panel-container').find('.details-panel'),
      isExpanded = $currentElement.hasClass('expanded-panel');
    
      this.$el.find('.details-panel').removeClass('expanded-panel');
      if(!isExpanded)
        $currentElement.addClass('expanded-panel');
    }
  },
  triggerAnchorClick: function(event){
    event.preventDefault();
    event.stopPropagation();
    $(event.target).parents('.js-click-action').find('a.img-inner-wrapper')[0].click();
   }
});
